<div class="container">
    <div class="mt-0 p-5 row bg-light border-top border-dark">
        <div class="col-12 col-md-6">
            <form [formGroup]="resetPasswordForm" autocomplete="off">
                <div class="mb-1 row">
                    <div class="col-12 col-md-4">
                        <app-label controlName="password" class="col-form-label">{{ 'reset_password.password' | translate }}</app-label>
                    </div>
                    <div class="col-12 col-md-8">
                        <input type="password" id="password" formControlName="password" class="form-control" />
                        <app-field-error-message controlName="password"></app-field-error-message>
                    </div>
                </div>
                <div class="mb-1 row">
                    <div class="col-12 col-md-4">
                        <app-label controlName="confirmPassword" class="col-form-label">{{ 'reset_password.confirmpassword' | translate }}</app-label>
                    </div>
                    <div class="col-12 col-md-8">
                        <input type="password" formControlName="confirmPassword" class="form-control" />
                        <app-field-error-message controlName="confirmPassword"></app-field-error-message>
                        <app-form-group-error-message errorMessage="password_does_not_match"></app-form-group-error-message>
                    </div>
                </div>
                <br />
                <div class="my-1">
                    <button type="submit" [appClickWait]="resetPassword" class="btn btn-primary float-end">
                        {{ 'common.save' | translate }}
                    </button>
                </div>
            </form>
        </div>
        <div class="ms-4 p-2">
            <app-html-viewer [type]="type"></app-html-viewer>
        </div>
    </div>
</div>
